window.fisherAnalytics = window.fisherAnalytics || {};
/*
    * DOM Listener Module
    * This module sets up event listeners on specified DOM elements.
    * It uses an IIFE to encapsulate its scope and avoid polluting the global namespace.
    * This is designed to handle elements that already exist in the DOM at page load.
    * If you need to handle dynamically added elements, consider using a MutationObserver as shown in dom-observer.js.
    * "method" is required
 */
window.fisherAnalytics.domListener = (function() {
    // All constants, variables, and functions are now scoped inside this IIFE
    const selectorsToWatch = ['.remove_item','[name^="quantity"]','input[type="radio"][name^="units"]'];
    const selectorsConfig = {
        '.remove_item': {
            description: 'Remove Item link on Canada cart page',
            method: [window.fisherAnalytics.utils.addEvents],
            eventName : 'cartRemove',
            eventType: 'click',
            listenerCallback: window.fisherAnalytics.cart.processLegacyRemoveItem
        },
        '[name^="quantity"]': {
            description: 'Quantity field on Canada cart page',
            method: [window.fisherAnalytics.utils.addEvents],
            eventName : 'cartUpdate',
            eventType: 'change',
            urlPattern: ['shop/orderdisplayview','shop/cart/','shop/ShoppingCart.html'],
            listenerCallback: window.fisherAnalytics.cart.processUpdateLegacyCart
        },
        'input[type="radio"][name^="units"]': {
            description: 'Quantity radio buttons on Canada cart page',
            method: [window.fisherAnalytics.utils.addEvents],
            eventName : 'cartUnitUpdate',
            eventType: 'change',
            urlPattern: ['shop/orderdisplayview','shop/cart/','shop/ShoppingCart.html'],
            listenerCallback: window.fisherAnalytics.cart.processUpdateUnitLegacyCart
        }
    }

    // Expose only what you want public
    return {
        selectorsToWatch,
        selectorsConfig
    };
})();
// Initial call to init() to handle any elements already present in the DOM
window.fisherAnalytics.utils.initModules(window.fisherAnalytics.domListener.selectorsToWatch, window.fisherAnalytics.domListener.selectorsConfig);
